module.exports = __webpack_public_path__ + "static/img/6.34a06be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/6.png
// module id = PyCY
// module chunks = 0